export const downloadVisitorsList = (url: string): void => {
  window.location.assign(url);
};
